import { colors as sunshineColors } from "@shinetools/sunshine";
const flattenColors = () => {
    const flattenedColors = {};
    for (const key in sunshineColors) if (sunshineColors[key]) if (typeof sunshineColors[key] == "string") flattenedColors[key] = sunshineColors[key];else for (const subKey in sunshineColors[key]) sunshineColors[key][subKey] && (flattenedColors[`${key}.${subKey}`] = sunshineColors[key][subKey]);
    return flattenedColors;
  },
  colors = flattenColors();
export { colors };